import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { apiService } from 'src/app/service/api.service';
import { JardinModel, ResponseJardinModel } from 'src/app/model/Jardin.model';
import { environment } from 'src/environments/environment';
import { BibliotecaService } from 'src/app/service/biblioteca.service';
import { BibliotecaModel, ResponseBiblioteca } from 'src/app/model/Biblioteca.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { NewPlanMejoraService } from 'src/app/service/newPlanMejora.service';
import { NewFaseAnual, ResponseNewFaseAnual } from 'src/app/model/NewFaseAnual.model';
import { PreviewComponent } from 'src/app/components/preview/preview.component';
import * as FileSaver from 'file-saver';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
//import axios from 'axios';
@Component({
  selector: 'app-biblioteca',
  templateUrl: './biblioteca.component.html',
  styleUrls: ['./biblioteca.component.css']
})
export class BibliotecaComponent implements OnInit {

  @ViewChild('modalInforme', { static: true }) modalInforme: TemplateRef<any>;

  @Input() simulacion: boolean;
  public isCollapsed1 = false;
  public isCollapsed2 = true;
  public isCollapsed3 = true;
  public isCollapsed4 = false;
  public isCollapsed5 = true;
  public isCollapsed6 = true;
  public pgc2023 = false;
  faseAnualData = new NewFaseAnual();
  urlInformeExcelPME1 : string = "";
  urlInformeExcelPME2 : string = "";
  
  dataJardin = new JardinModel();
  dataJardin2023 = new JardinModel();
  dataJardin2024 = new JardinModel();
  dataJardin2025 = new JardinModel();

  archivosGenerales:BibliotecaModel[];

  url:string ;
  apiEndpoint = environment.apiEndpoint;
  spinnerRef:any;

  constructor(
    public dialog: MatDialog,
    private api: apiService,
    private spinner: NgxSpinnerService,
    private bibliotecaService:BibliotecaService,
    private newPlanMejoraService: NewPlanMejoraService,
    private spinnerService: SpinnerService
  ) { }

  ngOnInit(): void {
    this.dataJardin = this.api.dataJardin;
    this.dataJardin2023 = this.api.dataJardin2023;
    this.dataJardin2024 = this.api.dataJardin2024;
    this.dataJardin2025 = this.api.dataJardin2025;
    this.getDocuments();
    this.existPGC2023();
    //this.getFaseAnual(this.dataJardin);
  }


  getDocuments(){
    this.spinner.show();
    this.bibliotecaService.API_GET_getall().subscribe((response: ResponseBiblioteca) => {
      this.archivosGenerales = response.payload;  
      this.spinner.hide();
    },
    (err) => {
      console.log(err);
      this.spinner.hide();
    });  
  }
  
  existPGC2023(){
    this.bibliotecaService.API_GET_existPGC2023(this.dataJardin.idJardinPeriodo).subscribe((response: any) => {
      this.pgc2023 = response;  
    },
    (err) => {
      console.log(err);
    });  
  }

  verDocumento(archivo:BibliotecaModel){
    /*this.url = this.apiEndpoint + "biblioteca/obtenerArchivo/"+archivo.id;
    this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    this.modal.open(this.modalInforme, { size: 'xl' });*/

    const dialogRef = this.dialog.open(PreviewComponent, {
			disableClose: true,
      		data: {file: this.apiEndpoint + "biblioteca/obtenerArchivo/"+archivo.id, name: archivo.fileName }
    	});
    
  }

  verDocumentoJardin(documento:string){
    let urlDoc = "";
    console.log(documento);
    switch(documento){

      case 'pei2025':{
        urlDoc = this.apiEndpoint + "jardin/imprimirProyectoEducativo/" + this.dataJardin2025.idJardinPeriodo;
        this.verArchivo(urlDoc,'pei.pdf');
        break;
      }
      case 'pei2024':{
        urlDoc = this.apiEndpoint + "jardin/imprimirProyectoEducativo/" + this.dataJardin2024.idJardinPeriodo;
        this.verArchivo(urlDoc,'pei.pdf');
        break;
      }
      case 'pei2023':{
        urlDoc = this.apiEndpoint + "jardin/imprimirProyectoEducativo2023/" + this.dataJardin2023.idJardinPeriodo;
        this.verArchivo(urlDoc,'pei2023.pdf');
        break;
      }
     case 'plan-mejora':{
        urlDoc = this.apiEndpoint + "jardin/imprimirInformePME/" + this.dataJardin2023.idJardinPeriodo;
        this.verArchivo(urlDoc,'autoevaluacion2025.pdf');
        break;
      }
     /*  case 'plan-mejora2025':{
        urlDoc = this.apiEndpoint + this.urlInformeExcelPME2;
        break;
      }*/
     case 'plan-convivencia2025':{
        urlDoc = this.apiEndpoint + "planGestionConvivencia/imprimir/"+this.dataJardin2025.idJardinPeriodo;
        this.verArchivo(urlDoc,'planConvivencia2025.pdf');
        break;
      }
      case 'plan-convivencia2024':{
        urlDoc = this.apiEndpoint + "planGestionConvivencia/imprimir/"+this.dataJardin2024.idJardinPeriodo;
        this.verArchivo(urlDoc,'planConvivencia2024.pdf');
        break;
      }
      case 'plan-convivencia-2023':{
        urlDoc = this.apiEndpoint + "planGestionConvivencia/2023/imprimir/"+this.dataJardin.idJardinPeriodo;
        this.verArchivo(urlDoc,'planConvivencia2023.pdf');
        break;
      }
      case 'reglamento':{
        urlDoc = this.apiEndpoint + "reglamentoInterno/imprimir/"+this.dataJardin.idJardinPeriodo;
        this.verArchivo(urlDoc,'reglamentoInterno.pdf');
        break;
      }
      case 'autoevaluacion2024':{
        urlDoc = this.apiEndpoint + "instrumentoAutoevaluacion/descargar/"+this.dataJardin2024.idJardinPeriodo;
        this.verArchivo(urlDoc,'autoevaluacion2024.pdf');
        break;
      }
      case 'autoevaluacion2025':{
        urlDoc = this.apiEndpoint + "instrumentoAutoevaluacion/descargar/"+this.dataJardin.idJardinPeriodo;
        this.verArchivo(urlDoc,'autoevaluacion2025.pdf');
        break;
      }
      
    }

  }

  public verArchivo(path : string, realName : string): void {

    	const dialogRef = this.dialog.open(PreviewComponent, {
			disableClose: true,
      		data: {file: path, name: realName }
    	});
	}

  /*close(){
    this.modal.dismissAll();
  }*/
  
 /* getFaseAnual(dataJardin: JardinModel) {
    this.newPlanMejoraService.API_GET_getFaseAnual(dataJardin.idJardinPeriodo).subscribe((response: ResponseNewFaseAnual) => {
      this.faseAnualData = response.payload;
      this.faseAnualData.periodos.forEach(periodo => {
        if (periodo.orden == 1){
          this.urlInformeExcelPME1 =  this.apiEndpoint + "pme/generarExcel/" + this.dataJardin.idJardinPeriodo + "/" + periodo.idPeriodo;
        }else if (periodo.orden == 2){
          this.urlInformeExcelPME2 = this.apiEndpoint +  "pme/generarExcel/" + this.dataJardin.idJardinPeriodo + "/" + periodo.idPeriodo;
        } 
      });
    },
      (err) => {
        console.log(err)
      });
  }*/

  downloadExcel() {
    this.spinnerRef = this.spinnerService.start();
    this.api.API_GET_downloadExcel( this.apiEndpoint + "pme/generarExcel/" + this.dataJardin.idJardinPeriodo+ "/2024" ).subscribe((response: any) => {

      FileSaver.saveAs(response,'PME.xls')
      this.spinnerService.stop(this.spinnerRef);
    },
    (err) => {
      this.spinnerService.stop(this.spinnerRef);
      this.dialog.open(MatDialog, {
        data: {
          icon: 'Check',
          message: 'This Alert Dialog opened asynchronously'
        }
      });
      console.log(err);
    }); 

}
  downloadExcel2025() {
    this.spinnerRef = this.spinnerService.start();
    this.api.API_GET_downloadExcel( this.apiEndpoint + "pme/generarExcel/" + this.dataJardin.idJardinPeriodo+ "/2025" ).subscribe((response: any) => {

      FileSaver.saveAs(response,'PME.xls')
      this.spinnerService.stop(this.spinnerRef);
    },
    (err) => {
      this.spinnerService.stop(this.spinnerRef);
      this.dialog.open(MatDialog, {
        data: {
          icon: 'Check',
          message: 'This Alert Dialog opened asynchronously'
        }
      });
      console.log(err);
    }); 

}


}
